import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.getElementById('main-content-layout-parent')?.scrollTo({ top: 0 });
  }, [pathname]);
  return null;
}
